import { helpers } from "@/helpers/index.ts";

const extractionApis = {
  getWebsiteSchema: (params: any, headers?: any) => {
    return helpers.api.get({
      headers,
      params,
      url: '/website_schema_only/get',
    });
  },
};

export default extractionApis;
